import { render, staticRenderFns } from "./widgetCheckbox.vue?vue&type=template&id=20ad12b4&scoped=true"
import script from "./widgetCheckbox.vue?vue&type=script&lang=js"
export * from "./widgetCheckbox.vue?vue&type=script&lang=js"
import style0 from "./widgetCheckbox.vue?vue&type=style&index=0&id=20ad12b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ad12b4",
  null
  
)

export default component.exports